import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>No page Found. Select again</p>
    </div>
  );
};
export default NotFound;
